<div>
  <label class="lum-filter__label">{{ label }}</label>
  <lum-filter-multiselect-chips
    [selectedOptions]="value"
    [placeholder]="placeholder"
    [options]="items"
    (selectOptionEvent)="onSelectOptionEvent($event)"
  ></lum-filter-multiselect-chips>
</div>
